/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DodRequest } from "../models/dod-request";
import { DodExportStatus } from "../models/dod-export-status";
import { DodJobEx } from "../models/dod-job-ex";
import { DodLayoutEx } from "../models/dod-layout-ex";
import { UpdateSharingStatus } from "../models/update-sharing-status";
import { EditDodRecurringRequest } from "../models/edit-dod-recurring-request";
import { DodEndPointEx } from "../models/dod-end-point-ex";
import { DodFilterType } from "../models/dod-filter-type";
@Injectable({
  providedIn: "root",
})
class DataOnDemandService extends __BaseService {
  static readonly dataOnDemandExportOnDemandPath =
    "/api/DataOnDemand/DataOnDemand";
  static readonly dataOnDemandGetLatestLayoutJobStatusPath =
    "/api/DataOnDemand/GetLatestLayoutJobStatus";
  static readonly dataOnDemandGetLatestPrintOnDemandJobsPath =
    "/api/DataOnDemand/GetLatestPrintOnDemandJobs";
  static readonly dataOnDemandGetPrintOnDemandStatusPath =
    "/api/DataOnDemand/GetDataOnDemandStatus/{dataOnDemandId}";
  static readonly dataOnDemandCreateDataOnDemandLayoutPath =
    "/api/DataOnDemand/CreateDataOnDemandLayout";
  static readonly dataOnDemandUpdateDataOnDemandLayoutPath =
    "/api/DataOnDemand/UpdateDataOnDemandLayout/{dataOnDemandLayoutId}";
  static readonly dataOnDemandDeleteDataOnDemandLayoutPath =
    "/api/DataOnDemand/DeleteDataOnDemandLayout/{dataOnDemandLayoutId}";
  static readonly dataOnDemandUpdateDodLayoutSharingPath =
    "/api/DataOnDemand/UpdateDodLayoutSharing";
  static readonly dataOnDemandCreateRecurringDodPath =
    "/api/DataOnDemand/CreateRecurringDod";
  static readonly dataOnDemandUpdateRecurringDodPath =
    "/api/DataOnDemand/UpdateRecurringDod/{dodRecurringId}";
  static readonly dataOnDemandDeleteRecurringDodPath =
    "/api/DataOnDemand/DeleteRecurringDod/{dodRecurringId}";
  static readonly dataOnDemandExecuteRecurringDodNowPath =
    "/api/DataOnDemand/ExecuteRecurringDodNow/{dodRecurringId}";
  static readonly dataOnDemandGetUserAvailableDodEndPointsPath =
    "/api/DataOnDemand/GetUserAvailableDodEndPoints";
  static readonly dataOnDemandGetUserAvailableDodLayoutsPath =
    "/api/DataOnDemand/GetUserAvailableDodLayouts";
  static readonly dataOnDemandGetAllDodEndPointsPath =
    "/api/DataOnDemand/GetAllDodEndPoints";
  static readonly dataOnDemandGetAllDodFilterTypesPath =
    "/api/DataOnDemand/GetAllDodFilterTypes";
  static readonly dataOnDemandClearAllUserCachePath =
    "/api/DataOnDemand/ClearAllUserCache";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param dodRequest undefined
   */
  dataOnDemandExportOnDemandResponse(
    dodRequest: DodRequest
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dodRequest;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/DataOnDemand`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param dodRequest undefined
   */
  dataOnDemandExportOnDemand(dodRequest: DodRequest): __Observable<number> {
    return this.dataOnDemandExportOnDemandResponse(dodRequest).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param dodLayoutIds undefined
   */
  dataOnDemandGetLatestLayoutJobStatusResponse(
    dodLayoutIds?: null | Array<number>
  ): __Observable<__StrictHttpResponse<Array<DodExportStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (dodLayoutIds || []).forEach((val) => {
      if (val != null)
        __params = __params.append("dodLayoutIds", val.toString());
    });
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetLatestLayoutJobStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodExportStatus>>;
      })
    );
  }
  /**
   * @param dodLayoutIds undefined
   */
  dataOnDemandGetLatestLayoutJobStatus(
    dodLayoutIds?: null | Array<number>
  ): __Observable<Array<DodExportStatus>> {
    return this.dataOnDemandGetLatestLayoutJobStatusResponse(dodLayoutIds).pipe(
      __map((_r) => _r.body as Array<DodExportStatus>)
    );
  }
  dataOnDemandGetLatestPrintOnDemandJobsResponse(): __Observable<
    __StrictHttpResponse<Array<DodJobEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetLatestPrintOnDemandJobs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodJobEx>>;
      })
    );
  }
  dataOnDemandGetLatestPrintOnDemandJobs(): __Observable<Array<DodJobEx>> {
    return this.dataOnDemandGetLatestPrintOnDemandJobsResponse().pipe(
      __map((_r) => _r.body as Array<DodJobEx>)
    );
  }

  /**
   * @param dataOnDemandId undefined
   */
  dataOnDemandGetPrintOnDemandStatusResponse(
    dataOnDemandId: number
  ): __Observable<__StrictHttpResponse<DodJobEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/DataOnDemand/GetDataOnDemandStatus/${dataOnDemandId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodJobEx>;
      })
    );
  }
  /**
   * @param dataOnDemandId undefined
   */
  dataOnDemandGetPrintOnDemandStatus(
    dataOnDemandId: number
  ): __Observable<DodJobEx> {
    return this.dataOnDemandGetPrintOnDemandStatusResponse(dataOnDemandId).pipe(
      __map((_r) => _r.body as DodJobEx)
    );
  }

  /**
   * @param request undefined
   */
  dataOnDemandCreateDataOnDemandLayoutResponse(
    request: DodLayoutEx
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/CreateDataOnDemandLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  dataOnDemandCreateDataOnDemandLayout(
    request: DodLayoutEx
  ): __Observable<number> {
    return this.dataOnDemandCreateDataOnDemandLayoutResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDataOnDemandLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dataOnDemandLayoutId`:
   */
  dataOnDemandUpdateDataOnDemandLayoutResponse(
    params: DataOnDemandService.DataOnDemandUpdateDataOnDemandLayoutParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/UpdateDataOnDemandLayout/${params.dataOnDemandLayoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDataOnDemandLayoutParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dataOnDemandLayoutId`:
   */
  dataOnDemandUpdateDataOnDemandLayout(
    params: DataOnDemandService.DataOnDemandUpdateDataOnDemandLayoutParams
  ): __Observable<number> {
    return this.dataOnDemandUpdateDataOnDemandLayoutResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param dataOnDemandLayoutId undefined
   */
  dataOnDemandDeleteDataOnDemandLayoutResponse(
    dataOnDemandLayoutId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/DeleteDataOnDemandLayout/${dataOnDemandLayoutId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dataOnDemandLayoutId undefined
   */
  dataOnDemandDeleteDataOnDemandLayout(
    dataOnDemandLayoutId: number
  ): __Observable<Blob> {
    return this.dataOnDemandDeleteDataOnDemandLayoutResponse(
      dataOnDemandLayoutId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDodLayoutSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `dodLayoutId`:
   */
  dataOnDemandUpdateDodLayoutSharingResponse(
    params: DataOnDemandService.DataOnDemandUpdateDodLayoutSharingParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updateSharingStatus;
    if (params.userId != null)
      __params = __params.set("userId", params.userId.toString());
    if (params.dodLayoutId != null)
      __params = __params.set("dodLayoutId", params.dodLayoutId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/UpdateDodLayoutSharing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateDodLayoutSharingParams` containing the following parameters:
   *
   * - `updateSharingStatus`:
   *
   * - `userId`:
   *
   * - `dodLayoutId`:
   */
  dataOnDemandUpdateDodLayoutSharing(
    params: DataOnDemandService.DataOnDemandUpdateDodLayoutSharingParams
  ): __Observable<boolean> {
    return this.dataOnDemandUpdateDodLayoutSharingResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param request undefined
   */
  dataOnDemandCreateRecurringDodResponse(
    request: EditDodRecurringRequest
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/CreateRecurringDod`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  dataOnDemandCreateRecurringDod(
    request: EditDodRecurringRequest
  ): __Observable<number> {
    return this.dataOnDemandCreateRecurringDodResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateRecurringDodParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dodRecurringId`:
   */
  dataOnDemandUpdateRecurringDodResponse(
    params: DataOnDemandService.DataOnDemandUpdateRecurringDodParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/UpdateRecurringDod/${params.dodRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `DataOnDemandService.DataOnDemandUpdateRecurringDodParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `dodRecurringId`:
   */
  dataOnDemandUpdateRecurringDod(
    params: DataOnDemandService.DataOnDemandUpdateRecurringDodParams
  ): __Observable<number> {
    return this.dataOnDemandUpdateRecurringDodResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandDeleteRecurringDodResponse(
    dodRecurringId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/DataOnDemand/DeleteRecurringDod/${dodRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandDeleteRecurringDod(dodRecurringId: number): __Observable<Blob> {
    return this.dataOnDemandDeleteRecurringDodResponse(dodRecurringId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandExecuteRecurringDodNowResponse(
    dodRecurringId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/DataOnDemand/ExecuteRecurringDodNow/${dodRecurringId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param dodRecurringId undefined
   */
  dataOnDemandExecuteRecurringDodNow(
    dodRecurringId: number
  ): __Observable<Blob> {
    return this.dataOnDemandExecuteRecurringDodNowResponse(dodRecurringId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  dataOnDemandGetUserAvailableDodEndPointsResponse(): __Observable<
    __StrictHttpResponse<Array<DodEndPointEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetUserAvailableDodEndPoints`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodEndPointEx>>;
      })
    );
  }
  dataOnDemandGetUserAvailableDodEndPoints(): __Observable<
    Array<DodEndPointEx>
  > {
    return this.dataOnDemandGetUserAvailableDodEndPointsResponse().pipe(
      __map((_r) => _r.body as Array<DodEndPointEx>)
    );
  }
  dataOnDemandGetUserAvailableDodLayoutsResponse(): __Observable<
    __StrictHttpResponse<Array<DodLayoutEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetUserAvailableDodLayouts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodLayoutEx>>;
      })
    );
  }
  dataOnDemandGetUserAvailableDodLayouts(): __Observable<Array<DodLayoutEx>> {
    return this.dataOnDemandGetUserAvailableDodLayoutsResponse().pipe(
      __map((_r) => _r.body as Array<DodLayoutEx>)
    );
  }
  dataOnDemandGetAllDodEndPointsResponse(): __Observable<
    __StrictHttpResponse<Array<DodEndPointEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetAllDodEndPoints`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodEndPointEx>>;
      })
    );
  }
  dataOnDemandGetAllDodEndPoints(): __Observable<Array<DodEndPointEx>> {
    return this.dataOnDemandGetAllDodEndPointsResponse().pipe(
      __map((_r) => _r.body as Array<DodEndPointEx>)
    );
  }
  dataOnDemandGetAllDodFilterTypesResponse(): __Observable<
    __StrictHttpResponse<Array<DodFilterType>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/GetAllDodFilterTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodFilterType>>;
      })
    );
  }
  dataOnDemandGetAllDodFilterTypes(): __Observable<Array<DodFilterType>> {
    return this.dataOnDemandGetAllDodFilterTypesResponse().pipe(
      __map((_r) => _r.body as Array<DodFilterType>)
    );
  }
  dataOnDemandClearAllUserCacheResponse(): __Observable<
    __StrictHttpResponse<Blob>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/DataOnDemand/ClearAllUserCache`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  dataOnDemandClearAllUserCache(): __Observable<Blob> {
    return this.dataOnDemandClearAllUserCacheResponse().pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module DataOnDemandService {
  /**
   * Parameters for DataOnDemandUpdateDataOnDemandLayout
   */
  export interface DataOnDemandUpdateDataOnDemandLayoutParams {
    request: DodLayoutEx;
    dataOnDemandLayoutId: number;
  }

  /**
   * Parameters for DataOnDemandUpdateDodLayoutSharing
   */
  export interface DataOnDemandUpdateDodLayoutSharingParams {
    updateSharingStatus: Array<UpdateSharingStatus>;
    userId?: number;
    dodLayoutId?: number;
  }

  /**
   * Parameters for DataOnDemandUpdateRecurringDod
   */
  export interface DataOnDemandUpdateRecurringDodParams {
    request: EditDodRecurringRequest;
    dodRecurringId: number;
  }
}

export { DataOnDemandService };
